<template>
<div ref="ElementoGrafico" :style="GetPositionStyle()">

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore" @OnClickChiudiPopup="AnnullaColore"></VUEColorPicker>
  
  <VUEColorPicker :Popup="PopupColorPickerBackground" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColoreBackground" @OnClickChiudiPopup="AnnullaColoreBackground"></VUEColorPicker>

  <VUEModal v-if="PopupNomePunto" 
         :Titolo="this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_CAMBIO_NOME',this.LinguaUtente)" 
          Altezza="120px" Larghezza="500px" 
         :PathLogo="require('@/assets/images/LogoDMS.png')" 
         :Programma="'DMSEW'"
         @onClickChiudiModal="AnnullaNomePunto">
    <template v-slot:Body>
        <input type="text" class="form-control" v-model="ModuloSelezionato.NomePunto"/>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaNomePunto" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ModuloSelezionato != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaNomePunto" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <div v-if="VisualizzaSoloImmagine" style="height: 20px; width: 20px; background-color: grey; position: absolute; top: 3px; left: 95%; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="MenuImpostazioni = !MenuImpostazioni">
    <a class="fa fa-bars" :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>  
    <div v-if="MenuImpostazioni" style="width: 20px; position: absolute; top: 25px; pointer-events: all">
      <div class="ZMGraficoGenericoBottoni" @click="EsportaComePDF()">
        <a class="fa fa-file-pdf-o" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
  </div> 

  <div style="float:left; width:64%;" :style="{'width' : VisualizzaSoloImmagine? '100%' : '64%'}" :height="AltezzaCanvas">
    <canvas ref="Canvas" :style="ObjStyleCanvas" @mousemove="OnMouseMove" @mousedown="OnMouseDown" @mouseup="OnMouseUp"></canvas>
    <div id="tooltip"></div>
  </div>
  


  <div style="float:left; width:36%;padding-right:7px;padding-left:7px" ref="DivPulsanti" v-if="!VisualizzaSoloImmagine">

    <div class="ZMSeparatoreScheda" style="margin-top: 0px;margin-bottom:0px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_IMMAGINE',this.LinguaUtente)}}</div>
    <div class="ZMNuovaRigaScheda" style="padding:0px;margin-top:3px">
      <label type="button" class="btn btn-info" style="float:left;font-weight:bold;width:50%">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_CARICA',this.LinguaUtente) }}      
          <input style="display:none;" type="file" id="InputImmagine" @change="LoadImmagineFromFile(elemento)" accept="image/*">
      </label>
      <div style="float:left;width:1%;background-color:white">&nbsp;</div>
      <button type="button" class="btn btn-info" style="float:left;font-weight:bold;width:49%" @click="OnClickCambiaBackground" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_BACKGROUND',this.LinguaUtente) }}</button>
    </div>
    <div style="clear:both;margin-bottom:3px"></div>
  
    <div class="ZMSeparatoreScheda" style="margin-top: 0px;margin-bottom:0px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_MODULI',this.LinguaUtente) }}</div>
    <div style="overflow:auto;max-height:150px;margin-bottom:3px">
      <div style="background-color:white">
        <div style="float:left;width:3%;">&nbsp;</div>
        <input style="float:left;width:3%;margin:0px" type="checkbox" @change="OnChangeCheckboxModuli" class="form-control" v-model="OggettoMontaggioGV.Origine.Selezionato"/>
        <div style="float:left;width:2%;">&nbsp;</div>
        <text style="float:left;width:90%;margin-top:6px;font-size:16px">{{ OggettoMontaggioGV.Origine.Nome }}</text>
        <div style="clear:both"></div>
      </div>
      <template v-for="(Modulo, index) in OggettoMontaggioGV.NumeroModuli" :key="index">
        <div style="" :style="{'background-color' : index % 2 == 0? ColoriSfondo.Arancione : 'white' }">
          <div style="float:left;width:3%;">&nbsp;</div>
          <input style="float:left;width:3%;margin:0px" type="checkbox" @change="OnChangeCheckboxModuli" class="form-control" v-model="Modulo.Selezionato"/>
          <div style="float:left;width:2%;">&nbsp;</div>
          <text style="float:left;width:90%;margin-top:6px;font-size:16px;cursor:pointer" @click="OnClickChangeNomePunto(Modulo)">{{ Modulo.Nome }}  [{{Modulo.NomePunto}}]</text>
          <div style="clear:both"></div>
        </div>
      </template>
    </div>

    <button type="button" class="btn btn-info" style="float:left;font-weight:bold;width:34%" @click="OnClickTuttimoduli" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_TUTTI',this.LinguaUtente) }}</button>
    <div style="float:left;width:1%;background-color:white">&nbsp;</div>
    <button type="button" class="btn btn-info" style="float:left;font-weight:bold;width:32%" @click="OnClickNessunModulo" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_NESSUNO',this.LinguaUtente) }}</button>
    <div style="float:left;width:1%;background-color:white">&nbsp;</div>
    <button type="button" class="btn btn-info" style="float:left;font-weight:bold;width:32%" @click="OnClickInvertiModuli" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_INVERTI',this.LinguaUtente) }}</button>
    
  
    <div style="clear:both;margin-bottom:3px"></div>
  

    <div class="ZMSeparatoreScheda" style="margin-top: 0px;margin-bottom:3px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_SOGLIE',this.LinguaUtente) }}</div>
    <div style="float:left;width:100%;margin-bottom:5px">
      <select style="float:left;width:100%;margin-right:5px" class="form-control" v-model="SogliaSelezionata" @change="OnChangeSoglia">
        <option v-for="(Soglia,index) in SoglieAttive" 
                  :Key="index"
                  :value="Soglia">
          {{Soglia.Nome}}
        </option>         
      </select>
    </div>


    <button type="button" class="btn btn-info" style="float:left;font-weight:bold;width:25%" @click="OnClickAggiungiSoglia" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_AGGIUNGI',this.LinguaUtente) }}</button>
    <div style="float:left;width:1%;background-color:white">&nbsp;</div>
    <button :disabled="SogliaSelezionata.PitchRollBloccato" type="button" class="btn btn-info" style="float:left;font-weight:bold;width:24%" @click="OnClickEliminaSoglia" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_ELIMINA',this.LinguaUtente) }}</button>
    <div style="float:left;width:1%;background-color:white">&nbsp;</div>
    <input type="checkbox" @change="OnChangeRepaint" style="float:right;width:4%;font-size:14px;margin-right:10px" class="form-control" v-model="SogliaSelezionata.VisualizzaMarkup"/>
    <label style="font-size:14px;margin-top:7px;float:right;width:24%;margin-left:7px;margin-top:10px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_MARKUP',this.LinguaUtente) }}</label>
    
    
    <div style="clear:both;margin-bottom:7px"></div>

    
    <div style="float: left;width:20%;">
      <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_NOME_SOGLIA',this.LinguaUtente) }}</label>
    </div>
    <div style="float:left;width:80%">
      <input type="text" class="form-control" v-model="SogliaSelezionata.Nome"/>
    </div>


    <div style="clear:both" :style="{'margin-bottom' : SpaziaturaDiv}"></div>


    <div class="ZMSeparatoreSchedaSubMenu" style="margin-top: 0px;margin-bottom:3px;width:50%;float:left">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_SOGLIE_PITCH_ROLL',this.LinguaUtente) }}</div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div class="ZMSeparatoreSchedaSubMenu" style="margin-top: 0px;margin-bottom:3px;width:49%;float:left">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_LAMPEGGIO',this.LinguaUtente) }}</div>

    <div style="clear:both;margin-bottom:3px"></div>

    <div style="width:50%; float:left">
      <div style="float: left;width:50%;">
        <label style="font-size:14px;margin-top:7px">Pitch/Roll [?]</label>
      </div>
      <div style="float:left;width:50%">
        <input v-if="SogliaSelezionata.PitchRollBloccato" type="number" step="0.01" class="form-control" @change="OnChangeRepaint" disabled v-model="SogliaSelezionata.PitchRoll"/>
        <input v-else type="number" step="0.01" class="form-control" @change="OnChangeRepaint" v-model="SogliaSelezionata.PitchRoll"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:49%; float:left">
      <div style="float: left;width:50%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_DURATA_LAMP',this.LinguaUtente) }} [sec]</label>
      </div>
      <div style="float:left;width:50%">
        <input type="number" step="1" class="form-control" min="0" @change="OnChangeDurata" v-model="SogliaSelezionata.Durata"/>
      </div>
    </div>


    <div style="clear:both" :style="{'margin-bottom' : SpaziaturaDiv}"></div>


    <!-- PALLINO -->

    <div class="ZMSeparatoreSchedaSubMenu" style="margin-top: 0px;margin-bottom:3px;width:100%;float:left">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_PALLINO',this.LinguaUtente) }}</div>
    <div style="width:38%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_RAGGIO',this.LinguaUtente) }} [px]</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" step="0.01" @change="OnChangeRepaint" class="form-control" v-model="SogliaSelezionata.PallinoRaggio"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.PallinoColoreRaggio}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.PallinoColoreRaggio, 'PallinoColoreRaggio')">&nbsp;</div>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE_LAMP',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.PallinoColoreRaggioLamp}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.PallinoColoreRaggioLamp, 'PallinoColoreRaggioLamp')">&nbsp;</div>
      </div>
    </div>

    <div style="clear:both;margin-bottom:3px"></div>

    <div style="width:38%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_BORDO',this.LinguaUtente) }} [px]</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" step="0.01" class="form-control" @change="OnChangeRepaint" v-model="SogliaSelezionata.PallinoBordo"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.PallinoColoreBordo}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.PallinoColoreBordo,'PallinoColoreBordo')">&nbsp;</div>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE_LAMP',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.PallinoColoreBordoLamp}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.PallinoColoreBordoLamp, 'PallinoColoreBordoLamp')">&nbsp;</div>
      </div>
    </div>


    <div style="clear:both" :style="{'margin-bottom' : SpaziaturaDiv}"></div>



    <!-- SEGMENTO -->

    <div class="ZMSeparatoreSchedaSubMenu" style="margin-top: 0px;margin-bottom:3px;width:100%;float:left">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_SEGMENTO',this.LinguaUtente) }}</div>
    <div style="width:38%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_SPESSORE',this.LinguaUtente) }} [px]</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" step="0.01" @change="OnChangeRepaint" class="form-control" v-model="SogliaSelezionata.SegmSpessore"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.SegmColoreSpessore}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.SegmColoreSpessore,'SegmColoreSpessore')">&nbsp;</div>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE_LAMP',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.SegmColoreSpessoreLamp}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.SegmColoreSpessoreLamp,'SegmColoreSpessoreLamp')">&nbsp;</div>
      </div>
    </div>


    <div style="clear:both" :style="{'margin-bottom' : SpaziaturaDiv}"></div>


    <!-- TAG -->

    <div class="ZMSeparatoreSchedaSubMenu" style="margin-top: 0px;margin-bottom:3px;width:100%;float:left">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_TAG',this.LinguaUtente) }}</div>
    <div style="width:38%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_LARGHEZZA',this.LinguaUtente) }} [px]</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" step="0.01" @change="OnChangeRepaint" class="form-control" v-model="SogliaSelezionata.TagLarghezza"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_ALTEZZA',this.LinguaUtente) }} [px]</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" @change="OnChangeRepaint" step="0.01" class="form-control" v-model="SogliaSelezionata.TagAltezza"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.TagColore}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.TagColore,'TagColore')">&nbsp;</div>
      </div>
    </div>

    <div style="clear:both;margin-bottom:3px"></div>

    <div style="width:38%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_BORDO',this.LinguaUtente) }} [px]</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" step="0.01" @change="OnChangeRepaint" class="form-control" v-model="SogliaSelezionata.TagBordo"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.TagBordoColore}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.TagBordoColore,'TagBordoColore')">&nbsp;</div>
      </div>
    </div>

    <div style="clear:both;margin-bottom:3px"></div>
   
    <div style="width:38%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_DIM_FONT',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <input type="number" step="0.01" @change="OnChangeRepaint" class="form-control" v-model="SogliaSelezionata.TagDimFont"/>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:60%;">
        <label style="font-size:14px;margin-top:7px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_COLORE',this.LinguaUtente) }}</label>
      </div>
      <div style="float:left;width:40%">
        <div class="ZMColorPickerDiv" :style="{'background-color' : SogliaSelezionata.TagDimFontColore}" style="width:100%;border:solid 1px #d9d9d9;margin-top:7px" @click="OnClickApriPopupColore(SogliaSelezionata.TagDimFontColore,'TagDimFontColore')">&nbsp;</div>
      </div>
    </div>
    <div style="float:left;width:1%;">&nbsp;</div>
    <div style="width:30%; float:left">
      <div style="float: left;width:100%;">
        <label style="font-size:14px;margin-top:7px;float:right;width:70%;margin-left:7px;margin-top:10px">{{ this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_GRAFICO_GV_GRASSETTO',this.LinguaUtente) }}</label>
        <input type="checkbox" @change="OnChangeRepaint" style="float:right;width:10%" class="form-control" v-model="SogliaSelezionata.TagDimFontGrassetto"/>
      </div>
    </div>

  </div>

</div>
</template>

<script>
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { SystemInformation, SFONDO, TIPO_ELEMENTO_PDF } from '@/SystemInformation';
import { TZGraph } from '@/utils/ZGraph.js'
import { TZDateFunct } from '@/utils/ZDateFunct.js'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEModal from '@/utils/VUEModal.vue'
import { saveAs } from 'file-saver'
import { TZStringConvFunct } from '@/utils/ZStringConvFunct'

// const POS_ORIGINE = 256

class TOggettoSogliaAllarme
{
  constructor(index)
  {
    this.Id        = index
    this.Nome      = 'NUOVA SOGLIA' + index
    this.PitchRoll = 0.00
    this.Durata    = 0
    this.PitchRollBloccato = false

    this.PallinoRaggio           = 3
    this.PallinoColoreRaggio     = 'red'
    this.PallinoColoreRaggioLamp = 'white'
    this.PallinoBordo            = 1
    this.PallinoColoreBordo      = 'white'
    this.PallinoColoreBordoLamp  = 'red'

    this.SegmSpessore            = 2
    this.SegmColoreSpessore      = 'red'
    this.SegmColoreSpessoreLamp  = 'white'

    this.TagLarghezza            = 20 
    this.TagAltezza              = 15
    this.TagColore               = 'white'
    this.TagBordo                = 1
    this.TagBordoColore          = 'red'
    this.TagDimFont              = 10
    this.TagDimFontColore        = 'black'
    this.TagDimFontGrassetto     = false
    this.VisualizzaMarkup        = true

    this.Eliminato = false
  }
}

class Modulo
{
  Selezionato            = false
  LampeggioOn            = false
  Nome                   = ''
  NomePunto              = ''
  Id                     = -1
  PosizioneXPercentuale  = 0.5
  PosizioneYPercentuale  = 0.5
  PosizioneXPlaceholderPercentuale  = 0.5
  PosizioneYPlaceholderPercentuale  = 0.5
  Pitch                  = null
  Roll                   = null
  Temperatura            = null

  constructor(Id, Pitch, Roll, Temperatura)
  {
    this.Nome      = 'Modulo nr. ' + Id
    this.NomePunto = Id.toString().padStart(3, '0')
    this.Id        = Id
    this.Pitch     = Pitch
    this.Roll      = Roll
    this.Temperatura = Temperatura
  }
}

export class TMontaggioGV
{
  constructor()
  {
    this.NumeroModuli = []

    this.Origine      = new Modulo('Origine')
    this.Immagine     = null
    this.VettoreSoglieDiAllarme = []
    this.ColoreBackground = '#d9d9d9'
  }
}



export default
{
  mixins: [ MixInsGestioneTraduzioni ],
  props : ['OggettoMontaggioGV', 'VisualizzaSoloImmagine', 'AltezzaImpostata', 'VettoreModuli', 'CatenaInfo', 'AddDatiPDF', 'Differenziale'],
  components: { VUEColorPicker, VUEModal},
  data()
  {
      return {
              UserInformation  : SystemInformation.UserInformation,
              ColoriSfondo     : SFONDO,
              LinguaUtente     : SystemInformation.UserInformation.Lingua,
              ObjStyleCanvas   : {
                                    display: 'block', // Assicurati che non ci siano spazi extra
                                    width: '100%',    // Il canvas occupa il 100% della larghezza
                                    height: '100%'    // Il canvas occupa il 100% dell'altezza
                                 },
              PopupColorPicker : false,
              PopupColorPickerBackground : false,
              ColoreInModifica : { 
                                    Colore     : '#000000',
                                    InModifica : null 
                                 },
              SogliaSelezionata   : null,
              SpaziaturaDiv       : '3px',
              AltezzaCanvas       : '0px',
              ModuloSelezionato   : null,
              PopupNomePunto      : false,
              MenuImpostazioni    : false,
              LeftImage           : 0,
              TopImage            : 0,
              WidthImage          : 0,
              HeightImage         : 0,
              XPos                : 0,
              YPos                : 0,
              InSpostamento       : false,
              InSpostamentoPlaceholder : false,
              PuntoSpostato       : null,
              PlaceholderSpostato : null,
              Immagine            : new Image(),
              TimerAvviato        : false,
              Timer               : null,
              Secondi             : 0,
              IsDifferenziale     : false,
      };
  },
  
  watch:
  {
    AddDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.InfoCatena.DatiPDF.push(this.GetDatiPerPDF())
        }
      }
    },

    Differenziale:
    {
      handler(NewValue)
      {
        this.IsDifferenziale = NewValue
      }
    }
  },

  beforeMount()
  {
    if(this.OggettoMontaggioGV.NumeroModuli.length == 0)
      this.InserisciModuli()
    else this.GestisciModuli()

    if(this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length == 0)
      this.AggiungiSoglia(true)
    this.SogliaSelezionata = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[0]
  },

  mounted() 
  {
    if(this.OggettoMontaggioGV.Immagine != null)
    {
      const Img = new Image();
      let Self = this

      // Aggiungi un evento di caricamento per essere sicuri che l'immagine sia stata completamente caricata
      Img.onload = function() 
      {
          Img.onload                       = undefined;
          // Quando l'immagine è stata caricata, copia il src nell'elemento img esistente
          Self.Immagine = Img;
          Self.PaintCanvas()
      };
      // Imposta il src dell'immagine per avviare il caricamento
      Img.src = this.OggettoMontaggioGV.Immagine;
    }
    else this.PaintCanvas();

    if(this.SogliaSelezionata.Durata != 0)
      this.AvviaTimer()

  },

  unmounted()
  {
    // this.Salvafile()
    this.FermaTimer()
  },  

  methods:
  {
    GestisciModuli()
    {
      if(this.VettoreModuli != undefined)
      {
        for(let i = 0; i < this.VettoreModuli.length; i++ )
        {
          let Trovato = false
          for(let j = 0; j < this.OggettoMontaggioGV.NumeroModuli.length; j++ )
          {
            if(this.VettoreModuli[i].Id == this.OggettoMontaggioGV.NumeroModuli[j].Id) 
            {
              this.OggettoMontaggioGV.NumeroModuli[j].Temperatura = this.VettoreModuli[i].Temperatura
              this.OggettoMontaggioGV.NumeroModuli[j].SpostNord = this.VettoreModuli[i].SpostNord
              this.OggettoMontaggioGV.NumeroModuli[j].SpostEst = this.VettoreModuli[i].SpostEst
              this.OggettoMontaggioGV.NumeroModuli[j].AzimuthSpostAng = this.VettoreModuli[i].AzimuthSpostAng
              Trovato = true
              break;
            } 
          }

          if(!Trovato)
          {
            this.OggettoMontaggioGV.NumeroModuli.push(new Modulo(this.VettoreModuli[i].Id, this.VettoreModuli[i].Pitch, this.VettoreModuli[i].Roll, this.VettoreModuli[i].Temperatura))
          }
        }
      }
    },

    InserisciModuli()
    {
      if(this.VettoreModuli != undefined)
        for(let i = 0; i < this.VettoreModuli.length; i++ )
          this.OggettoMontaggioGV.NumeroModuli.push(new Modulo(this.VettoreModuli[i].Id, this.VettoreModuli[i].Pitch, this.VettoreModuli[i].Roll, this.VettoreModuli[i].Temperatura))
    },

    Salvafile()
    {
      // Dati da scrivere nel file
      const content = JSON.stringify(this.OggettoMontaggioGV);
      const blob = new Blob([content], { type: 'text/plain' });

      // Crea un URL per il blob
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'ProvaJsonOggettoMontaggio.txt'; // nome del file

      // Simula il click per avviare il download
      link.click();
    },

    RecuperaFile()
    {
      document.getElementById('fileInput').addEventListener('change', (event) => 
      {
        const file = event.target.files[0]; // Ottieni il primo file selezionato
        if (file) 
        {
            const reader = new FileReader();
            reader.onload = () => {
                const data = JSON.parse(reader.result);
                this.Oggetto = null
                this.Oggetto = data; // Contenuto del file
            };
            reader.readAsText(file); // Legge il file come testo
        }
      });
    },

    OnClickTuttimoduli()
    {
      this.OggettoMontaggioGV.NumeroModuli.forEach(function(Modulo)
      {
        Modulo.Selezionato = true
      })
      this.OggettoMontaggioGV.Origine.Selezionato = true
      this.OnChangeRepaint()
    },

    OnClickNessunModulo()
    {
      this.OggettoMontaggioGV.NumeroModuli.forEach(function(Modulo)
      {
        Modulo.Selezionato = false
      })
      this.OggettoMontaggioGV.Origine.Selezionato = false
      this.OnChangeRepaint()
    }, 
    
    OnClickInvertiModuli()
    {
      this.OggettoMontaggioGV.NumeroModuli.forEach(function(Modulo)
      {
        Modulo.Selezionato = !Modulo.Selezionato
      })
      this.OggettoMontaggioGV.Origine.Selezionato = !this.OggettoMontaggioGV.Origine.Selezionato
      this.OnChangeRepaint()
    }, 
    
    ResizeCanvas() 
    {
      const canvasContainer    = this.$refs.Canvas.parentElement;
      this.$refs.Canvas.width  = canvasContainer.clientWidth

      this.$refs.Canvas.height = this.$refs.DivPulsanti? this.$refs.DivPulsanti.clientHeight : this.AltezzaImpostata
      this.AltezzaCanvas       = this.$refs.Canvas.height + 'px'
      this.InserisciImmagine()
    },

    ResizeImage()
    {
      if(this.$refs.Canvas.width - this.Immagine.width < 0)
      {
        this.Immagine.width = this.$refs.Canvas.width
        this.Immagine.height = (this.Immagine.height / this.Immagine.width) * this.Immagine.width;
      }
      if(this.$refs.Canvas.height - this.Immagine.height < 0)
      {
        this.Immagine.height = this.$refs.Canvas.height
        this.Immagine.width  = (this.Immagine.width / this.Immagine.height) * this.Immagine.height;
      }
    },

    InserisciImmagine()
    {
      var Context  = this.$refs.Canvas.getContext('2d')

      Context.clearRect(0,0, this.$refs.Canvas.width, this.$refs.Canvas.height)
      
      Context.fillStyle = this.OggettoMontaggioGV.ColoreBackground;
      Context.fillRect(0,0, this.$refs.Canvas.width, this.$refs.Canvas.height);

      let CanvasWidth  = this.$refs.Canvas.width
      let CanvasHeight = this.$refs.Canvas.height

      if(this.Immagine.width <= 0 || this.Immagine.height <= 0)
      {
        this.LeftImage   = 0
        this.TopImage    = 0
        this.WidthImage  = CanvasWidth
        this.HeightImage = CanvasHeight
        return
      }

      // Scaling "contain": un unico fattore di scala (il minore tra i due rapporti)
      // garantisce che l'immagine sia interamente visibile, senza tagli né deformazioni.
      let Scala = Math.min(CanvasWidth / this.Immagine.width, CanvasHeight / this.Immagine.height)

      let NewWidth  = this.Immagine.width  * Scala
      let NewHeight = this.Immagine.height * Scala

      this.LeftImage   = (CanvasWidth  - NewWidth)  / 2
      this.TopImage    = (CanvasHeight - NewHeight) / 2
      this.WidthImage  = NewWidth
      this.HeightImage = NewHeight

      Context.drawImage(this.Immagine, this.LeftImage, this.TopImage, NewWidth, NewHeight)
    },

    LoadImmagineFromFile()
    {
      let Self    = this;
      let Reader  = new FileReader()
      let ImgFile = document.getElementById('InputImmagine')
      
      Reader.readAsDataURL(ImgFile.files[0])

      Reader.onload = function (e) 
      {
        var Img = new Image()
        Img.onload = function () 
        {
          Img.onload                       = undefined;
          Self.OggettoMontaggioGV.Immagine = Img.src
          Self.Immagine.src                = Img.src
          Self.PaintCanvas()
        }
        Img.src = e.target.result
      } 
    },

    OnClickAggiungiSoglia()
    {
      this.FermaTimer()
      this.AggiungiSoglia()
      this.SogliaSelezionata = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length - 1]
      this.OnChangeRepaint()
    },

    AggiungiSoglia(PrimaSoglia)
    {
      let Oggetto = new TOggettoSogliaAllarme(this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length)

      if(PrimaSoglia)
      {
        Oggetto.PitchRollBloccato = true
        Oggetto.PitchRoll         = 0.00
      }

      this.OggettoMontaggioGV.VettoreSoglieDiAllarme.push(Oggetto)
    },

    OnClickEliminaSoglia()
    {
      this.SogliaSelezionata.Eliminato = true
      this.SogliaSelezionata           = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[0]
      this.OnChangeSoglia()
    },

    OnClickCambiaBackground()
    {
      this.ColoreInModifica.Colore    = this.OggettoMontaggioGV.ColoreBackground
      this.PopupColorPickerBackground = true
    },

    ConfermaColoreBackground()
    {
      this.OggettoMontaggioGV.ColoreBackground = this.ColoreInModifica.Colore
      this.PopupColorPickerBackground          = false
      this.PaintCanvas()
    },

    AnnullaColoreBackground()
    {
      this.PopupColorPickerBackground = false
    },

    OnClickApriPopupColore(Colore, InModifica)
    {
      this.ColoreInModifica.Colore     = Colore
      this.ColoreInModifica.InModifica = InModifica
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      switch(this.ColoreInModifica.InModifica)
      {
        case 'PallinoColoreRaggio'     : this.SogliaSelezionata.PallinoColoreRaggio     = this.ColoreInModifica.Colore
                                         break;
        case 'PallinoColoreRaggioLamp' : this.SogliaSelezionata.PallinoColoreRaggioLamp = this.ColoreInModifica.Colore
                                         break;
        case 'PallinoColoreBordo'      : this.SogliaSelezionata.PallinoColoreBordo      = this.ColoreInModifica.Colore
                                         break;
        case 'PallinoColoreBordoLamp'  : this.SogliaSelezionata.PallinoColoreBordoLamp  = this.ColoreInModifica.Colore
                                         break;
        case 'SegmColoreSpessore'      : this.SogliaSelezionata.SegmColoreSpessore      = this.ColoreInModifica.Colore
                                         break;
        case 'SegmColoreSpessoreLamp'  : this.SogliaSelezionata.SegmColoreSpessoreLamp  = this.ColoreInModifica.Colore
                                         break;
        case 'TagColore'               : this.SogliaSelezionata.TagColore               = this.ColoreInModifica.Colore
                                         break;
        case 'TagBordoColore'          : this.SogliaSelezionata.TagBordoColore          = this.ColoreInModifica.Colore
                                         break;
        case 'TagDimFontColore'        : this.SogliaSelezionata.TagDimFontColore        = this.ColoreInModifica.Colore
                                         break;
        default                        : break;
      }

      this.PopupColorPicker = false
      this.OnChangeRepaint()
    },

    AnnullaColore()
    {
      this.PopupColorPicker = false
    },

    OnClickChangeNomePunto(Modulo)
    {
      this.ModuloSelezionato         = Modulo
      this.ModuloSelezionato.Annulla = Modulo.NomePunto
      this.PopupNomePunto            = true
    },

    AnnullaNomePunto()
    {
      this.ModuloSelezionato.NomePunto = this.ModuloSelezionato.Annulla
      this.PopupNomePunto              = false
      this.ModuloSelezionato           = null
    },

    ConfermaNomePunto()
    {
      this.PopupNomePunto              = false
      this.ModuloSelezionato           = null
    },

    DrawOrigine(Context, SogliaSelezionata)
    {
      if(SogliaSelezionata != null)
      {
        let ColorePallino      = 'red'
        let ColorePallinoBordo = 'white'

        // Disegna punti
        if (this.OggettoMontaggioGV.Origine.LampeggioOn) 
        {
          ColorePallino      = SogliaSelezionata.PallinoColoreRaggioLamp
          ColorePallinoBordo = SogliaSelezionata.PallinoColoreBordoLamp
        }
        else
        {
          ColorePallino      = SogliaSelezionata.PallinoColoreRaggio
          ColorePallinoBordo = SogliaSelezionata.PallinoColoreBordo
        }

        let X = this.GetXPixelFromPercentuale(0.5)
        let Y = this.GetYPixelFromPercentuale(0.5)

        if(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale != null)
          X = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale)
        if(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale != null)
          Y = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale)

        Context.beginPath();
        Context.arc(X, Y, SogliaSelezionata.PallinoRaggio, 0, 2 * Math.PI);  // Disegna un cerchio
        Context.fillStyle   = ColorePallino;                       // Imposta il colore del cerchio
        Context.fill(); 
        Context.lineWidth   = SogliaSelezionata.PallinoBordo; // Imposta la larghezza del contorno
        Context.strokeStyle = ColorePallinoBordo;                  // Imposta il colore del contorno
        Context.stroke(); 
      }
    },

    // Percentuali relative all'area dell'immagine (letterboxing escluso), non al canvas intero.
    GetXPixelFromPercentuale(Percentuale)
    {
      return this.LeftImage + Percentuale * this.WidthImage
    },

    GetYPixelFromPercentuale(Percentuale)
    {
      return this.TopImage + Percentuale * this.HeightImage
    },

    GetXPercentualeFromPixel(Pixel)
    {
      if (this.WidthImage <= 0)
        return 0

      let Percentuale = (Pixel - this.LeftImage) / this.WidthImage
      return parseFloat(Math.min(1, Math.max(0, Percentuale)).toFixed(4))
    },

    GetYPercentualeFromPixel(Pixel)
    {
      if (this.HeightImage <= 0)
        return 0

      let Percentuale = (Pixel - this.TopImage) / this.HeightImage
      return parseFloat(Math.min(1, Math.max(0, Percentuale)).toFixed(4))
    },

    // Coordinate mouse nello spazio bitmap del canvas (gestisce lo stretch CSS width/height 100%).
    GetMouseCanvasCoords(event)
    {
      const Canvas = this.$refs.Canvas
      const Rect   = Canvas.getBoundingClientRect()
      const ScaleX = Rect.width  > 0 ? Canvas.width  / Rect.width  : 1
      const ScaleY = Rect.height > 0 ? Canvas.height / Rect.height : 1

      return {
        x    : (event.clientX - Rect.left) * ScaleX,
        y    : (event.clientY - Rect.top)  * ScaleY,
        cssX : event.clientX - Rect.left,
        cssY : event.clientY - Rect.top
      }
    },

    CanDrawModulo(IdModulo)
    {
      return this.OggettoMontaggioGV.NumeroModuli[IdModulo].Selezionato &&
             ((this.OggettoMontaggioGV.NumeroModuli[IdModulo].Pitch <= 360 && this.OggettoMontaggioGV.NumeroModuli[IdModulo].Roll <= 360) ||
              this.OggettoMontaggioGV.NumeroModuli[IdModulo].SogliaForzata != null)
    },

    GetDatiPerPDF()
    {
      let ObjParametri = {}
      ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_VERTICALE
      let Dati    = []

      if(this.OggettoMontaggioGV.Origine.Selezionato)
      {
        let ModuloOrigine = this.OggettoMontaggioGV.Origine
        ModuloOrigine.Id = -1
        ModuloOrigine.SogliaModulo = this.GetSogliaPerOrigine()
        Dati.push(ModuloOrigine)
      }

      for (let i = 0; i < this.OggettoMontaggioGV.NumeroModuli.length; i++)
      {
        let CurrentModulo = this.OggettoMontaggioGV.NumeroModuli[i]

        if(CurrentModulo.Pitch && CurrentModulo.Roll)
        {
          CurrentModulo.SogliaModulo = this.GetSogliaPerModulo(this.OggettoMontaggioGV.NumeroModuli[i]) ?? this.GetSogliaPerModulo(this.OggettoMontaggioGV.NumeroModuli[0])
          CurrentModulo.ModAllarme = (Math.sqrt(Math.pow(CurrentModulo.Pitch.toFixed(3), 2) + Math.pow(CurrentModulo.Roll.toFixed(3), 2))).toFixed(3)
          if(CurrentModulo.Selezionato)
            Dati.push(CurrentModulo)
        }
      }
      
      ObjParametri.Titolo = 'DMS GV layout'
      ObjParametri.DatiAcquisiti = Dati 
      ObjParametri.DatiTabella   = [...Dati].reverse()
      ObjParametri.ListaSoglie = this.OggettoMontaggioGV.VettoreSoglieDiAllarme 
      ObjParametri.Intestazione  = {
                                      Sito          : '',
                                      Progetto      : '',
                                      Monitoraggio  : '',
                                      Installazione : '',
                                      Calibrazione  : '',
                                      Note          : ''
                                    }
      // ObjParametri.ObjUdmA = {
      //                          Tipo: this.GetTraduzioneLabel('Generic','TKN_PROF',this.LinguaUtente), 
      //                          Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ']'
      //                        }
      ObjParametri.ObjUdmA = {
                               Tipo: this.GetTraduzioneLabel('Generic','TKN_ID',this.LinguaUtente), 
                               Udm:  this.GetTraduzioneLabel('UdmGenerali','TKN_ID_N',this.LinguaUtente)
                             }
      ObjParametri.ObjUdmB = {
                               Tipo: this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente), 
                               Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
                             }
      ObjParametri.ObjUdmC = {
                               Tipo: this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente), 
                               Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
                             }
      // ObjParametri.ObjUdmD = {
      //                          Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGenerico','TKN_GRAF_GEN_MOD',this.LinguaUtente), 
      //                          Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
      //                        }
      // ObjParametri.ObjUdmE = {
      //                          Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_ALLARME',this.LinguaUtente), 
      //                          Udm: ''
      //                        }
      ObjParametri.ObjUdmD = {
                                Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_RISULT_SPOST_ANG',this.LinguaUtente), 
                                Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
                             }

      ObjParametri.ObjUdmE = {
                               Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_STATO',this.LinguaUtente), 
                               Udm: ''
                             }

      ObjParametri.ObjUdmF = {
                               Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_SVIL_SPOST_NORD',this.LinguaUtente), 
                               Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
                             }

      ObjParametri.ObjUdmG = {
                                Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_SVIL_SPOST_EST',this.LinguaUtente), 
                                Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
                             }

      ObjParametri.ObjUdmH = {
                                Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_AZIMUTH_SPOST_ANGOL',this.LinguaUtente), 
                                Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
                             }
      
      ObjParametri.ObjUdmI = {
                               Tipo: this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente), 
                               Udm: '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'
                             }

      ObjParametri.ObjUdmJ = {
                                Tipo: this.GetTraduzioneLabel('VUEComponenteGraficoGV','TKN_N_EVENTI_ACCEL',this.LinguaUtente), 
                                Udm: ''
                             }

                                    
      ObjParametri.DatiGrafici = new TZGraph(this.$refs.Canvas);
      ObjParametri.DatiGrafici.GraficoLinee = 'imgLine'
      ObjParametri.DatiGrafici.ListaPunti = Dati

      ObjParametri.GraficoLinee = 'imgLine'
      ObjParametri.NomePDF = 'DMS_GV_layout'
      ObjParametri.DataAllineamento = ''
      ObjParametri.IsDifferenziale = this.IsDifferenziale
      ObjParametri.DataOdierna = TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date())

      ObjParametri.DatiPerRiepilogo = this.OggettoMontaggioGV

      
      for (let i = 0; i < this.InfoCatena.LsInfoCatena.length; i++)
      {
        let Voce = this.InfoCatena.LsInfoCatena[i]
        switch (Voce.Descrizione)
        {
          case ('Sito'):
          {
            ObjParametri.Intestazione.Sito = Voce.Valore
            break
          }
          case ('Progetto'):
          {
            ObjParametri.Intestazione.Progetto = Voce.Valore
            break
          }
          case ('Intervallo monitoraggio'):
          {
            ObjParametri.Intestazione.Monitoraggio = Voce.Valore
            break
          }
         case ('Data installazione'):
          {
            ObjParametri.Intestazione.Installazione = Voce.Valore + " "
            break
          }
          case ('Ora installazione'):
          {
            ObjParametri.Intestazione.Installazione += Voce.Valore + " "
            break
          }

          case ('Data calibrazione'):
          {
            ObjParametri.Intestazione.Calibrazione = Voce.Valore + " "
            break
          }
          case ('Ora calibrazione'):
          {
            ObjParametri.Intestazione.Calibrazione += Voce.Valore + " "
            break
          }
        }
      }
      
      return ObjParametri      
    },
    
    EsportaComePDF()
    {
      let ObjParametri = this.GetDatiPerPDF()
      let DataOdierna = new Date()
      let NomeGrafico = this.InfoCatena.DatiCatena.DESCRIZIONE.replace('-', '') + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + ObjParametri.NomePDF + '.pdf'
      let VettoreGrafici = []

      let ObjGrafico  =  {
                            Catena          : this.InfoCatena.DatiCatena.CHIAVE,
                            TipoElementoPDF : ObjParametri.TipoElementoPDF,
                            Grafici         : [ObjParametri]
                          }

      VettoreGrafici.push(ObjGrafico)

      SystemInformation.AdvQuerySiti.ExecuteExternalScript('StampaPDFAll',  { 
                                                                                ChiaveSito : this.InfoCatena.DatiCatena.CHIAVE_SITO,
                                                                                VettoreDati : VettoreGrafici
                                                                              },
                                                        function(Result)
                                                        {                                                
                                                          saveAs(TZStringConvFunct.Base64AsBlob(Result.PDF), NomeGrafico)
                                                        },
                                                        function(HTTPError,SubHTTPError,Response)
                                                        {
                                                          SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                        })
    },

    DrawModulo(IdModulo, Context, SogliaSelezionata)
    {
      if(this.CanDrawModulo(IdModulo))
      {
        if(SogliaSelezionata != null)
        {
          let ColorePallino      = 'red'
          let ColorePallinoBordo = 'white'

          // Disegna punti
          if (this.OggettoMontaggioGV.NumeroModuli[IdModulo].LampeggioOn) 
          {
            ColorePallino      = SogliaSelezionata.PallinoColoreRaggioLamp
            ColorePallinoBordo = SogliaSelezionata.PallinoColoreBordoLamp
          }
          else
          {
            ColorePallino      = SogliaSelezionata.PallinoColoreRaggio
            ColorePallinoBordo = SogliaSelezionata.PallinoColoreBordo
          }

          let X = this.GetXPixelFromPercentuale(0.5)
          let Y = this.GetYPixelFromPercentuale(0.5)

          if(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneXPercentuale != null)
            X = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneXPercentuale)
          if(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneYPercentuale != null)
            Y = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneYPercentuale)

          Context.beginPath();
          Context.arc(X, Y, SogliaSelezionata.PallinoRaggio, 0, 2 * Math.PI);  // Disegna un cerchio
          Context.fillStyle   = ColorePallino;                       // Imposta il colore del cerchio
          Context.fill(); 
          Context.lineWidth   = SogliaSelezionata.PallinoBordo; // Imposta la larghezza del contorno
          Context.strokeStyle = ColorePallinoBordo;                  // Imposta il colore del contorno
          Context.stroke(); 



          // Disegna i tag
          if(SogliaSelezionata.VisualizzaMarkup)
          {
            // Impostiamo le dimensioni e posizione del rettangolo
            X = this.GetXPixelFromPercentuale(0.4);
            Y = this.GetYPixelFromPercentuale(0.4)
            let Width  = SogliaSelezionata.TagLarghezza;
            let Height = SogliaSelezionata.TagAltezza;

            if(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneXPlaceholderPercentuale != null)
              X = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneXPlaceholderPercentuale)
            if(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneYPlaceholderPercentuale != null)
              Y = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.NumeroModuli[IdModulo].PosizioneYPlaceholderPercentuale)
            
            // Disegnamo il rettangolo
            Context.fillStyle = SogliaSelezionata.TagColore;  // Colore del rettangolo
            Context.fillRect(X, Y, Width, Height);
            
            // Impostiamo le caratteristiche del testo
            Context.font         = (SogliaSelezionata.TagDimFontGrassetto? 'bold ' : '') + SogliaSelezionata.TagDimFont + 'px Calibri';  // Tipo e dimensione del font
            Context.fillStyle    = SogliaSelezionata.TagDimFontColore;  // Colore del testo
            Context.textAlign    = 'center'; // Allineamento orizzontale al centro
            Context.textBaseline = 'middle'; // Allineamento verticale al centro
            
            // Disegnamo il testo all'interno del rettangolo
            Context.fillText(this.OggettoMontaggioGV.NumeroModuli[IdModulo].NomePunto, X + Width / 2, Y + Height / 2);

            // Colore del bordo
            Context.strokeStyle = SogliaSelezionata.TagBordoColore;  // Colore del bordo
            Context.lineWidth   = SogliaSelezionata.TagBordo;        // Spessore del bordo
            Context.strokeRect(X, Y, Width, Height); // Disegna solo il bordo
          }
        }
      }
    },

    PaintCanvas()
    {
      this.ResizeCanvas()

      const Context = this.$refs.Canvas.getContext('2d')

      if(!this.VisualizzaSoloImmagine)
      {
        if(this.ModuliSelezionati.length > 1 || (this.ModuliSelezionati.length > 0 && this.OggettoMontaggioGV.Origine.Selezionato))
          this.DrawSegmenti(Context, true)

        for(let i = 0; i < this.OggettoMontaggioGV.NumeroModuli.length; i++)
          if(this.OggettoMontaggioGV.NumeroModuli[i].Selezionato)
            this.DrawModulo(i, Context, this.SogliaSelezionata);

        if(this.OggettoMontaggioGV.Origine.Selezionato)
          this.DrawOrigine(Context, this.SogliaSelezionata)
      }
      else
      {
        if(this.ModuliSelezionati.length > 1 || (this.ModuliSelezionati.length > 0 && this.OggettoMontaggioGV.Origine.Selezionato))
          this.DrawSegmenti(Context, false)

        for(let i = 0; i < this.OggettoMontaggioGV.NumeroModuli.length; i++)
          if(this.OggettoMontaggioGV.NumeroModuli[i].Selezionato)
            this.DrawModulo(i, Context, this.GetSogliaPerModulo(this.OggettoMontaggioGV.NumeroModuli[i]));

        if(this.OggettoMontaggioGV.Origine.Selezionato)
          this.DrawOrigine(Context, this.GetSogliaPerOrigine())
      }
    },

    DrawSegmenti(Context, UtilizzaSogliaSelezionata)
    {
      let SogliaSelezionata = UtilizzaSogliaSelezionata? this.SogliaSelezionata : this.GetSogliaPerOrigine()

      if(this.OggettoMontaggioGV.Origine.Selezionato && (this.OggettoMontaggioGV.NumeroModuli[0] != null && this.OggettoMontaggioGV.NumeroModuli[0].Selezionato))
      {
        Context.beginPath();
        Context.moveTo(this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale), this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale));  // Partiamo dal primo punto
        Context.lineTo(this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.NumeroModuli[0].PosizioneXPercentuale), this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.NumeroModuli[0].PosizioneYPercentuale));  // Arriviamo al secondo punto
        Context.strokeStyle = this.OggettoMontaggioGV.NumeroModuli[0].LampeggioOn? SogliaSelezionata.SegmColoreSpessoreLamp : SogliaSelezionata.SegmColoreSpessore;  // Colore della linea
        Context.lineWidth   = SogliaSelezionata.SegmSpessore;  // Spessore della linea
        Context.stroke(); 
      }

      for(let i = 1; i < this.OggettoMontaggioGV.NumeroModuli.length; i++)
      {
        if(!UtilizzaSogliaSelezionata)
          SogliaSelezionata = this.GetSogliaPerModulo(this.OggettoMontaggioGV.NumeroModuli[i])

        if(this.OggettoMontaggioGV.NumeroModuli[i - 1].Selezionato && this.OggettoMontaggioGV.NumeroModuli[i].Selezionato)
        {
          let PointPrec = this.OggettoMontaggioGV.NumeroModuli[i - 1]
          let Point     = this.OggettoMontaggioGV.NumeroModuli[i]

          Context.beginPath();
          Context.moveTo(this.GetXPixelFromPercentuale(PointPrec.PosizioneXPercentuale), this.GetYPixelFromPercentuale(PointPrec.PosizioneYPercentuale));  // Partiamo dal primo punto
          Context.lineTo(this.GetXPixelFromPercentuale(Point.PosizioneXPercentuale),     this.GetYPixelFromPercentuale(Point.PosizioneYPercentuale));  // Arriviamo al secondo punto
          Context.strokeStyle = Point.LampeggioOn? SogliaSelezionata.SegmColoreSpessoreLamp : SogliaSelezionata.SegmColoreSpessore;
          Context.lineWidth   = SogliaSelezionata.SegmSpessore;  // Spessore della linea
          Context.stroke(); 
        }
      }
    },

    GetSogliaPerModulo(Modulo)
    {
      let Result = null

      for(let i = 0; i < this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length; i++)
        if(Math.abs(Modulo.Pitch) >= this.OggettoMontaggioGV.VettoreSoglieDiAllarme[i].PitchRoll || Math.abs(Modulo.Roll) >= this.OggettoMontaggioGV.VettoreSoglieDiAllarme[i].PitchRoll)
          Result = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[i];

      if(Result == null && this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length != 0)
        Result = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[0]

      return Result
    },

    GetSogliaPerOrigine()
    {
      let Result = null
      if(this.OggettoMontaggioGV.NumeroModuli.length != 0)
      {
        let Modulo = this.OggettoMontaggioGV.NumeroModuli[0]

        for(let i = 0; i < this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length; i++)
          if(Math.abs(Modulo.Pitch) >= this.OggettoMontaggioGV.VettoreSoglieDiAllarme[i].PitchRoll || Math.abs(Modulo.Roll) >= this.OggettoMontaggioGV.VettoreSoglieDiAllarme[i].PitchRoll)
            Result = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[i];
      }

      if(Result == null && this.OggettoMontaggioGV.VettoreSoglieDiAllarme.length != 0)
        Result = this.OggettoMontaggioGV.VettoreSoglieDiAllarme[0]

      return Result
    },

    OnChangeCheckboxModuli()
    {
      this.PaintCanvas()
    },

    OnChangeSoglia()
    {
      this.FermaTimer()
      this.OnChangeDurata()
      this.OnChangeRepaint()
    },

    OnChangeRepaint()
    {
      this.PaintCanvas()
    },

    OnChangeDurata()
    {
      if(this.SogliaSelezionata.Durata < 0)
        this.SogliaSelezionata.Durata = 0
      this.SogliaSelezionata.Durata = Math.round(this.SogliaSelezionata.Durata)
      if(this.SogliaSelezionata.Durata != 0)
      {
        this.FermaTimer(true)
        this.AvviaTimer()
      }
      else this.FermaTimer(true)
    },

    CambiaTuttiModuliLampeggio()
    {
      this.OggettoMontaggioGV.NumeroModuli.forEach(Modulo => 
      {
        Modulo.LampeggioOn = !Modulo.LampeggioOn
      });
      this.OggettoMontaggioGV.Origine.LampeggioOn = !this.OggettoMontaggioGV.Origine.LampeggioOn
    },

    ImpostaLampeggiFalse()
    {
      this.OggettoMontaggioGV.NumeroModuli.forEach(Modulo => 
      {
        Modulo.LampeggioOn = false
      });
      this.OggettoMontaggioGV.Origine.LampeggioOn = false
    }, 

    FermaTimer(DisegnaCanvas)
    {
      if (this.Timer != null) 
      {
        clearInterval(this.Timer);  // Ferma il timer
        this.Secondi = 0;
        this.ImpostaLampeggiFalse()

        if(DisegnaCanvas)
          this.PaintCanvas()

        this.Timer = null
      } 
    },

    AvviaTimer() 
    {
      if(this.Timer == null)
      {
        let Durata = this.VisualizzaSoloImmagine? 1 : this.SogliaSelezionata.Durata

        this.Timer = setInterval(() => {
          this.Secondi++;
          if(!this.VisualizzaSoloImmagine)
            this.CambiaTuttiModuliLampeggio();
          else this.CambiaLampeggiInImmagine()
          
          this.PaintCanvas()
        }, Durata * 1000);  // Incrementa ogni secondo
      }
    },

    CambiaLampeggiInImmagine()
    {
      this.ModuliSelezionati.forEach(Modulo => 
      {
        let Soglia = this.GetSogliaPerModulo(Modulo)

        if(Soglia.Durata != 0 && this.Secondi >= Soglia.Durata && this.Secondi % Soglia.Durata == 0)
          Modulo.LampeggioOn = !Modulo.LampeggioOn
      });

      let SogliaOrigine = this.GetSogliaPerOrigine()

      if(SogliaOrigine.Durata != 0 && this.Secondi >= SogliaOrigine.Durata && this.Secondi % SogliaOrigine.Durata == 0)
        this.OggettoMontaggioGV.Origine.LampeggioOn = !this.OggettoMontaggioGV.Origine.LampeggioOn
    },

    OnMouseDown(event) 
    {
      if(!this.VisualizzaSoloImmagine)
      {
        let Mouse   = this.GetMouseCanvasCoords(event)
        let MouseX  = Mouse.x
        let MouseY  = Mouse.y
        let Trovato = false

        for (let i = 0; i < this.ModuliSelezionati.length; i++)
        {
          let TopY    = this.GetYPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneYPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
          let BottomY = this.GetYPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneYPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo
          let LeftX   = this.GetXPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneXPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
          let RightX  = this.GetXPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneXPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo

          if (MouseX >= LeftX && MouseX <= RightX && MouseY >= TopY  && MouseY <= BottomY)
          {
            this.PuntoSpostato = this.ModuliSelezionati[i]
            this.InSpostamento = true;  // Inizia a trascinare
            Trovato = true
            break;
          }

          TopY    = this.GetYPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneYPlaceholderPercentuale) - this.SogliaSelezionata.TagBordo
          BottomY = this.GetYPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneYPlaceholderPercentuale) + (this.SogliaSelezionata.TagAltezza) + this.SogliaSelezionata.TagBordo

          LeftX   = this.GetXPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneXPlaceholderPercentuale) - this.SogliaSelezionata.TagBordo
          RightX  = this.GetXPixelFromPercentuale(this.ModuliSelezionati[i].PosizioneXPlaceholderPercentuale) + (this.SogliaSelezionata.TagLarghezza) + this.SogliaSelezionata.TagBordo

          if (MouseX >= LeftX && MouseX <= RightX && MouseY >= TopY  && MouseY <= BottomY)
          {
            this.PuntoSpostato = this.ModuliSelezionati[i]
            this.InSpostamentoPlaceholder = true;  // Inizia a trascinare
            Trovato = true
            break;
          }
        }

        if(!Trovato)
        {
          let TopY    = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
          let BottomY = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo
          let LeftX   = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
          let RightX  = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo

          if (MouseX >= LeftX && MouseX <= RightX && MouseY >= TopY  && MouseY <= BottomY)
          {
            this.PuntoSpostato = this.OggettoMontaggioGV.Origine
            this.InSpostamento = true;  // Inizia a trascinare
          }
        }
      }
    },

    // Funzione per spostare il punto mentre viene trascinato
    OnMouseMove(event) 
    {
        if (this.InSpostamento) 
        {
          let Mouse = this.GetMouseCanvasCoords(event)

          // Offset con segno: il tag mantiene la posizione relativa al pallino (anche se è a sinistra/sopra).
          let DifferenzatraPlaceholderEPuntoX = this.GetXPixelFromPercentuale(this.PuntoSpostato.PosizioneXPlaceholderPercentuale) - this.GetXPixelFromPercentuale(this.PuntoSpostato.PosizioneXPercentuale)
          let DifferenzatraPlaceholderEPuntoY = this.GetYPixelFromPercentuale(this.PuntoSpostato.PosizioneYPlaceholderPercentuale) - this.GetYPixelFromPercentuale(this.PuntoSpostato.PosizioneYPercentuale)

          this.PuntoSpostato.PosizioneXPercentuale = this.GetXPercentualeFromPixel(Mouse.x)
          this.PuntoSpostato.PosizioneYPercentuale = this.GetYPercentualeFromPixel(Mouse.y)

          this.PuntoSpostato.PosizioneXPlaceholderPercentuale = this.GetXPercentualeFromPixel(Mouse.x + DifferenzatraPlaceholderEPuntoX)
          this.PuntoSpostato.PosizioneYPlaceholderPercentuale = this.GetYPercentualeFromPixel(Mouse.y + DifferenzatraPlaceholderEPuntoY)

          const tooltip                      = document.getElementById('tooltip');
          tooltip.style.display              = 'none';
          
          this.PaintCanvas();  // Ridiisegna il punto alla nuova posizione
        }
        else
        {
          if(this.InSpostamentoPlaceholder)
          {
            let Mouse = this.GetMouseCanvasCoords(event)

            this.PuntoSpostato.PosizioneXPlaceholderPercentuale = this.GetXPercentualeFromPixel(Mouse.x)
            this.PuntoSpostato.PosizioneYPlaceholderPercentuale = this.GetYPercentualeFromPixel(Mouse.y)

            const tooltip                      = document.getElementById('tooltip');
            tooltip.style.display              = 'none';
            
            this.PaintCanvas();  // Ridiisegna il tag nella nuova posizione
          }
          else this.GetTooltip(event)
        }
    },

    GetTooltip(event)
    {
      let pointHovered = false;
      const tooltip    = document.getElementById('tooltip');
      const Mouse      = this.GetMouseCanvasCoords(event)
      const mouseX     = Mouse.x
      const mouseY     = Mouse.y
      let Trovato      = false;
 
      // Controlliamo ogni punto per vedere se il mouse è sopra
      for (let i = 0; i < this.ModuliSelezionati.length; i++)
      {
        let point   = this.ModuliSelezionati[i]
        let TopY    = this.GetYPixelFromPercentuale(point.PosizioneYPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
        let BottomY = this.GetYPixelFromPercentuale(point.PosizioneYPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo

        let LeftX   = this.GetXPixelFromPercentuale(point.PosizioneXPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
        let RightX  = this.GetXPixelFromPercentuale(point.PosizioneXPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo

        if (mouseX >= LeftX && mouseX <= RightX && mouseY >= TopY  && mouseY <= BottomY)
        {
          // Se il mouse è sopra il punto, mostriamo il nome nel tooltip
          tooltip.style.display = 'block';
          tooltip.style.left    = `${Mouse.cssX + 30}px`; // Posizione CSS del tooltip (non bitmap)
          tooltip.style.top     = `${Mouse.cssY + 30}px`;
          tooltip.textContent   = point.NomePunto;
          pointHovered          = true;
          Trovato               = true
        }
      }

      if(!Trovato && this.OggettoMontaggioGV.Origine.Selezionato)
      {
        let TopY    = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
        let BottomY = this.GetYPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneYPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo

        let LeftX   = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale) - this.SogliaSelezionata.PallinoRaggio - this.SogliaSelezionata.PallinoBordo
        let RightX  = this.GetXPixelFromPercentuale(this.OggettoMontaggioGV.Origine.PosizioneXPercentuale) + this.SogliaSelezionata.PallinoRaggio + this.SogliaSelezionata.PallinoBordo

        if (mouseX >= LeftX && mouseX <= RightX && mouseY >= TopY  && mouseY <= BottomY)
        {
          // Se il mouse è sopra il punto, mostriamo il nome nel tooltip
          tooltip.style.display = 'block';
          tooltip.style.left    = `${Mouse.cssX + 30}px`;
          tooltip.style.top     = `${Mouse.cssY + 30}px`;
          tooltip.textContent   = this.OggettoMontaggioGV.Origine.NomePunto;
          pointHovered          = true;
          Trovato               = true
        }
      }

      // Se il mouse non è sopra nessun punto, nascondiamo il tooltip
      if (!pointHovered) 
        tooltip.style.display = 'none';
    },

    // Funzione per fermare il drag
    OnMouseUp() 
    {
      if(!this.VisualizzaSoloImmagine)
      {
        this.InSpostamento = false;  // Ferma il trascinamento
        this.InSpostamentoPlaceholder = false;  // Ferma il trascinamento
      }
    },

    GetPositionStyle()
    {
      return {'cursor' : this.InSpostamento || this.InSpostamentoPlaceholder ? 'grab' : 'auto'}
    },
  },

  computed:
  {
    InfoCatena:
    {
      get()
      {
        return this.CatenaInfo
      }
    },

    ModuliSelezionati:
    {
      get()
      {
        let Result = []
        this.OggettoMontaggioGV.NumeroModuli.forEach(Modulo => 
        {
          if(Modulo.Selezionato)
            Result.push(Modulo)
        })
        return Result
      }
    },

    SoglieAttive:
    {
      get()
      {
        let Result = []

        this.OggettoMontaggioGV.VettoreSoglieDiAllarme.forEach(Soglia =>
        {
          if(!Soglia.Eliminato)
            Result.push(Soglia)
        })
        return Result
      }
    }
  }
}
</script>

<style>
#tooltip {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 5px;
    border-radius: 5px;
    display: none; /* Nascondiamo il tooltip inizialmente */
}

</style>
